// extracted by mini-css-extract-plugin
export default {"visuals":"visuals_visuals__hv5P-"};